import {userApi} from '../../../api';
import {AuthenticationError} from '../../../errors';

import {
	GLOBAL__ACTIONSCOPE,
	AUTHENTICATE__ACTIONTYPES,
	RENEW_AUTHENTICATION__ACTIONTYPES,
	LOGOUT__ACTIONTYPE,
	CLEAR_AUTHENTICATION__ACTIONTYPE,
} from '../../constants/global';
import {getScopedAsyncAction} from '../util/async';
import { redirectToLoggedOut } from '../../../history';

export function logIn(request: AuthenticateRequest): AsyncAction<Partial<UserState>> {
	return getScopedAsyncAction(AUTHENTICATE__ACTIONTYPES, GLOBAL__ACTIONSCOPE, () => {
		return userApi.authenticate(request)
			.then(authorization => {
				return {
					username: request.username,
					authorization,
				};
			});
	});
}

export function unifiedLogIn(code: string, loginApi: string): AsyncAction<Partial<UserState>> {
	return getScopedAsyncAction(AUTHENTICATE__ACTIONTYPES, GLOBAL__ACTIONSCOPE, () => {
		return fetch(`${loginApi}/auth_tokens/${code}`, {
			method: 'PUT',
		})
		.then(response => response.json())
		.then(response => {
			// case where auth token is invalid
			if (response.error) {
				redirectToLoggedOut();
				return {
					username: null,
					authorization: null,
				};
			} else {
				return {
					username: response.username,
					authorization: {
						authorizationToken: response.auth_token,
						expiresTimestamp: response.expires_timestamp,
					},
				};
			}
		});
	});
}

export function renewAuthentication(authorizationToken: string): AsyncAction<AuthenticateResponse> {
	return getScopedAsyncAction(RENEW_AUTHENTICATION__ACTIONTYPES, GLOBAL__ACTIONSCOPE, () => {
		return userApi.renewAuthentication(authorizationToken)
			.then(authorization => {
				return authorization;
			});
	});
}

export function logOut(): LogoutAction {
	return {
		type: LOGOUT__ACTIONTYPE,
		scope: GLOBAL__ACTIONSCOPE,
	};
}

function isAuthenticationTokenExpired({authorization}: UserState): boolean {
	return !!authorization && +authorization.expiresTimestamp <= Date.now();
}

function getClearAuthenticationAction(): ClearAuthenticationAction {
	return {
		type: CLEAR_AUTHENTICATION__ACTIONTYPE,
		error: new AuthenticationError(
			'SESSION_TIMED_OUT',
			'Session timed out.  Please login again'),
		scope: GLOBAL__ACTIONSCOPE,
	};
}

export function clearAuthenticationIfExpired(): ThunkAction<void> {
	return (dispatch, getState) => {
		const user = getState().global.user;
		if (isAuthenticationTokenExpired(user)) {
			dispatch(getClearAuthenticationAction());
		}
	};
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/store/actions/global/auth.ts